import { Drama } from 'lucide-react'
import type { ReactNode } from 'react'
import { FlashToaster } from '@/components/flash-toaster'

export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted/40 p-4">
      <div className="flex items-center gap-2 text-lg font-semibold">
        <Drama className="size-5" /> Scripted
      </div>
      <div className="w-full max-w-sm">{children}</div>
      <FlashToaster />
    </div>
  )
}
